import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    positionTitle: "Ma position",
    positionNotFind: "Impossible d'obtenir votre position. Si vous souhaitez qu'Activmed puisse utiliser votre position, vous pouvez vérifier les permissions de votre navigateur pour autoriser ce site à utiliser votre position actuelle.",
    locationNotSupported: "La géolocalisation n'est pas supportée par ce navigateur. Certaines fonctionnalités de ce site peuvent être impactées."
};

export type _I18nMapComponent = typeof _fr;

const _en: _I18nMapComponent = {
    positionTitle: "Your position",
    positionNotFind: "We can't get your current location. If you want Activmed to use your current location, please check your browser's permissions to authorize this site to use your current location.",
    locationNotSupported: "Geolocation is not supported by this browser. Some features of this web site can be impacted."
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nMapComponent(lang?: string): _I18nMapComponent {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}